import React from "react";
import {Helmet} from "react-helmet";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CssBaseline from "@material-ui/core/CssBaseline";
import {GTMProvider} from "@elgorditosalsero/react-gtm-hook";
import {useKeycloakFunctions} from "../../hooks/useKeycloakFunctions";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import Main from "./main/Main";
import GlobalLoader from "../widget/skeleton/GlobalLoader";
import {AnalyticsProvider} from "../../store/providers/AnalyticsProvider";
import RouteProvider from "../../store/providers/RouteProvider";

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: "hidden",
        position: "relative",
        height: "inherit",
    },
}));

const Layout = () => {
    const classes = useStyles();
    const {initialized} = useKeycloakFunctions();

    const url = new URL(window.location.href);
    const displayIdleDialog = url.searchParams.get("displayIdleDialog");
    const gtmParams = { id: process.env.GOOGLE_TAG_MANAGER_ID, customDomain: process.env.GOOGLE_TAG_MANAGER_URL || undefined };

    return (
        <div className={classes.root}>
            <Helmet>
                <link
                    rel="canonical"
                    href={window.location.origin + window.location.pathname}
                />
            </Helmet>
            <CssBaseline />
            <GTMProvider state={gtmParams}>
                <AnalyticsProvider>
                    <Header />
                    {initialized ? (
                        <>
                            <RouteProvider>
                                <Main displayIdleDialog={displayIdleDialog === "true" || false} />
                            </RouteProvider>
                            <Footer url={url} />
                        </>
                    ) : (
                        <GlobalLoader />
                    )}
                </AnalyticsProvider>
            </GTMProvider>
        </div>
    );
};

export default Layout;
